var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';
import { Card, Image, Button, IcIcon } from './../../index';
import { UilTimesCircle, UilFile } from '@iconscout/react-unicons';
import './FileUploader.css';

var SelectedFileViewer = function SelectedFileViewer(_ref) {
    var file = _ref.file,
        removeFile = _ref.removeFile,
        index = _ref.index;

    var _useState = useState(null),
        srcToView = _useState[0],
        setSrcToView = _useState[1];

    var name = file.name,
        type = file.type;


    useEffect(function () {
        if (type.includes("image")) {
            var reader = new FileReader();
            reader.onload = function () {
                setSrcToView(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }, [file]);

    return React.createElement(
        Card,
        { key: name, className: 'file-preview-container m-2' },
        React.createElement(
            'div',
            { className: 'close-button' },
            React.createElement(
                Button,
                { variant: 'outline-danger', onClick: removeFile, 'data-index': index },
                React.createElement(IcIcon, { icon: UilTimesCircle, size: '2x' })
            )
        ),
        React.createElement(
            Card.Body,
            { className: 'text-center' },
            srcToView ? React.createElement(Image, { src: srcToView, fluid: true }) : React.createElement(IcIcon, { icon: UilFile, size: '5x' })
        ),
        React.createElement(
            Card.Footer,
            null,
            React.createElement(
                'div',
                { className: 'text-truncate' },
                React.createElement(
                    'small',
                    null,
                    name
                )
            )
        )
    );
};
var FileUploader = function FileUploader(_ref2) {
    var accept = _ref2.accept,
        multiple = _ref2.multiple,
        maxSize = _ref2.maxSize,
        onDropRejected = _ref2.onDropRejected,
        onDropAccepted = _ref2.onDropAccepted,
        onChange = _ref2.onChange;

    var _useState2 = useState([]),
        acceptedFileList = _useState2[0],
        setAcceptedFileList = _useState2[1];

    var onDrop = useCallback(function (acceptedFiles, rejectedFiles) {
        setAcceptedFileList([].concat(acceptedFileList, acceptedFiles));
        if (onDropAccepted) {
            onDropAccepted(acceptedFiles);
        }
        if (rejectedFiles.length > 0) {
            onDropRejected({ message: 'Invalid file' + (multiple ? '(s)' : '') + ' selected, Only allowed ' + accept + ' file formats.', type: 'invalid file' });
        }
    }, [acceptedFileList, setAcceptedFileList]);

    var onDropReject = useCallback(function (files) {

        if (files.length > 0) {
            files.forEach(function (file) {
                if (file.size > maxSize) {
                    onDropRejected({ message: 'The size of the \'' + file.name + '\' file is larger than the maximum allowed file size of ' + maxSize + ' bytes.', type: 'large file' });
                    return;
                }
            });
        } else {
            onDropRejected({ message: 'Invalid file' + (multiple ? '(s)' : '') + ' selected, Only allowed ' + accept + ' file formats.', type: 'invalid file' });
        }
    }, []);

    var removeFile = useCallback(function (e) {
        e.stopPropagation();
        var index = e.currentTarget.dataset.index;
        var filesList = [].concat(acceptedFileList);
        filesList.splice(index, 1);
        setAcceptedFileList(filesList);
    }, [acceptedFileList]);

    useEffect(function () {
        onChange(acceptedFileList);
    }, [acceptedFileList]);

    var _useDropzone = useDropzone({ onDrop: onDrop, accept: accept, multiple: multiple, maxSize: maxSize, onDropRejected: onDropReject }),
        getRootProps = _useDropzone.getRootProps,
        getInputProps = _useDropzone.getInputProps,
        isDragActive = _useDropzone.isDragActive;

    var disabledDnD = useMemo(function () {
        if (multiple) {
            return false;
        } else if (acceptedFileList.length > 0) {
            return true;
        }
    }, [acceptedFileList, multiple]);
    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            Card,
            { border: isDragActive ? 'success' : 'default', className: 'file-uploader' },
            React.createElement(
                Card.Body,
                getRootProps(),
                React.createElement(
                    'div',
                    { className: 'd-flex flex-row justify-content-center' },
                    acceptedFileList.map(function (file, index) {
                        return React.createElement(SelectedFileViewer, { file: file, key: file.name, removeFile: removeFile, index: index });
                    })
                ),
                React.createElement('input', _extends({}, getInputProps(), { disabled: disabledDnD })),
                !disabledDnD && React.createElement(
                    'p',
                    { className: 'text-center' },
                    'Drag \'n\' drop the file',
                    multiple ? '(s)' : '',
                    ' here, or click to select ',
                    multiple ? '' : 'a',
                    ' file',
                    multiple ? '(s)' : ''
                )
            )
        )
    );
};

FileUploader.defaultProps = {
    accept: '',
    maxSize: 3145728,
    multiple: true,
    onDropRejected: function onDropRejected(response) {},
    onDropAccepted: null,
    onChange: function onChange(newFileList) {}
};
FileUploader.propTypes = process.env.NODE_ENV !== "production" ? {
    /** 
     * accepted file formats. eg: 'image/jpeg, image/png' for images
    */
    accept: PropTypes.string,
    /**
     * Max allowed file size in bytes
     */
    maxSize: PropTypes.number,
    /**
     * Single/ Multiple files
     */
    multiple: PropTypes.bool,
    /**
     * onDropRejected callback
     */
    onDropRejected: PropTypes.func,
    /**
     * on dropped file accepted callback
     */
    onDropAccepted: PropTypes.func,
    /**
     * callback whenever list of file(s) list has changed. Return all the file list
     */
    onChange: PropTypes.func

} : {};

export default FileUploader;